import Twig from 'twig'
//import {formatPhone} from '../src/components/Location'

export default class LocationRenderer {
    constructor(fetcher, locations) {
        this.fetcher = fetcher
        this.locations = locations
        this.renderLocations()
    }

    renderLocations() {
        // holds elements that represent the currently designated location
        const currentEls = []

        this.locations.forEach(el => {
            if (!el.template) {
                el.template = Twig.twig({
                    data: el.innerHTML,
                })
            }

            const locationId = el.getAttribute("data-designator-location")

            // currently designated location is handled via event
            if ((locationId === 'designated') || !locationId) {
                currentEls.push(el)
                return
            }

            // static locations are rendered right away
            this.renderLocation(el, locationId)
        })

        window.addEventListener('locator.designated', e => {
            currentEls.forEach(el => {
                this.renderLocation(el, e.location.id)
            })
        })
    }

    renderLocation(el, locationId) {
        this.fetcher(locationId).then(data => {
            el.location = data
            el.innerHTML = el.template.render(data)

            // evaluate JS in case template contains any
            el.querySelectorAll("script").forEach(script => {
                eval(script.text)
            })

            // finally, show the element
            el.style.visibility = 'visible'
            if (el.style.display === 'none') {
                el.style.display = 'block'
            }

            el.dispatchEvent(new Event('locator.location-ready', {
                bubbles: true,
                cancelable: true,
            }))
        })
    }
}
